<template>
  <div id="main">
    <section-definition :title="page.title"></section-definition>

    <my-show-error
            v-model="dialog_show_error"
            :error="show_error_obj"
    ></my-show-error>


    <!--------------dialog for pdf previewer--------------------------------------------------------------------------->
    <v-dialog v-model="dialog"  max-width="1200px" attach="#main">

      <v-card>
          <v-card-title>
          <span class="headline">Report Card Preview</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="close_preview">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-card-title>

        <pdf :src="pdf_data"
             style="display: inline-block; width: 100%">
        </pdf>

      </v-card>
    </v-dialog>



    <!--------------dialog for send email------------------------------------------------------------------------------>
    <v-dialog v-model="dialog_email" persistent  max-width="700" attach="#main">

      <v-card>
        <v-card-title>
          <span class="headline">Report Card Preview</span>
        </v-card-title>

        <v-card-text>
          <pdf :src="pdf_data"
               style="display: inline-block; width: 100%">
          </pdf>
        </v-card-text>

        <v-card-text>
          <v-layout wrap>
\
            <v-flex xs12>
              <span class="myheader">Client Users</span>
              <ul style="list-style-type:none">
                <li
                  v-for="(value, i) in users_client"
                  :key="value._id"
                >
                  <v-checkbox
                      class="mt-0"
                      :label="`${value.name} (${value.app_metadata.title}, ${value.email})`"
                      v-model="value.loc_checked"
                      hide-details
                  ></v-checkbox>
                </li>
              </ul>

              <div class="myheader pt-3" >Agency Users</div>
              <ul style="list-style-type:none">
                <li
                  v-for="(value, i) in users_agency"
                  :key="value._id"
                >
                  <v-checkbox
                    class="mt-0"
                    :label="`${value.name} (${value.app_metadata.role}, ${value.email})`"
                    v-model="value.loc_checked"
                    hide-details
                    :readonly="!is_admin"
                  ></v-checkbox>

                </li>
              </ul>
            </v-flex>

            <v-flex xs12 pb-4></v-flex>

          </v-layout>
        </v-card-text>

        <v-layout row v-if="form_error_txt">
          <v-spacer></v-spacer>
          <v-flex shrink class="pr-3 red--text"> {{form_error_txt}}</v-flex>
        </v-layout>


        <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="primary"  @click="close_email_dialog">Close</v-btn>
          <v-btn color="primary" :loading="submit_email_users" @click="send_emails">Send Emails</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>








     <!--------------dialog for bulk ops--------------------------------------------------------------------------->
     <v-dialog v-model="show_bulk"   persistent>

        <v-card>
           <v-card-title>
              <span class="headline">Bulk Operations</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="close_bulk_dialog" :disabled="running_bulk">
                 <v-icon>clear</v-icon>
              </v-btn>
           </v-card-title>

           <div class="pa-3" style="display: flex; flex-direction: column; align-items: center">

              <div style="width: 500px">
                 <div style="display: flex">
                    <v-switch
                        label="Generate Reports"
                        hide-details
                        class="dense reverse-label-checkbox"
                        v-model="bulk_settings.gen_reports"
                    />

                    <v-switch
                        label="Email Reports"
                        hide-details
                        class="dense reverse-label-checkbox"
                        v-model="bulk_settings.email_reports"
                    />
                 </div>

                 <v-switch
                     label="Overwrite If Report Exists"
                     hide-details
                     class="dense reverse-label-checkbox"
                     v-model="bulk_settings.overwrite_existing"
                 />


              </div>


           </div>
           <div style="display: flex; justify-content: flex-end">
              <v-btn color="primary" @click="gen_reports_batch" :loading="running_bulk">
                 Run Bulk Operations
              </v-btn>
           </div>



           <div class="pa-2">
              <v-progress-linear
                  v-if="running_bulk"
                  :value="batch_progress"
              />

              <table  id="bulk-table" v-if="bulk_res.log.length>0">
                 <tr style="text-align: left">
                    <th></th>
                    <th>Org
                       <!--<template v-if="bulk_has_dealer">/Dealer</template>-->
                    </th>
                    <th v-if="bulk_has_dealer">Dealer</th>
                    <th v-if="bulk_has_sp">Sales Person</th>
                    <th>Curriculum</th>
                    <th>Generated</th>
                    <th>Emailed</th>
                 </tr>
                 <tr v-for="(r, i) in bulk_res.log" :key="'bulk-log'+i">
                    <td>{{i+1}}</td>
                    <td>{{r.org.name}}
                       <!--<template v-if="bulk_has_dealer">/{{r.dealer.name}}</template>-->
                    </td>
                    <td v-if="bulk_has_dealer">{{r.dealer.name}}</td>
                    <td v-if="bulk_has_sp">{{r.sales_person.name}}</td>
                    <td>{{r.curriculum.name}}</td>
                    <td>{{r.generated}}</td>
                    <td>{{r.emailed}}</td>
                 </tr>
              </table>
           </div>



        </v-card>
     </v-dialog>




































    <!---------------------------------------------main data display--------------------------------------------------->
    <v-container fluid>

      <v-layout wrap>

         <v-flex xs12 sm6 md2>
            <v-autocomplete
                label="Report Type"
                :items="report_list"
                item-value="val"
                item-text="txt"
                v-model="report_type"
                @change="get_reports_local"
            />
         </v-flex>

         <v-btn v-if="is_admin" color="primary" @click="show_bulk=true">
            Bulk Operations
         </v-btn>

         <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
               <div   v-on="on">
                  <v-switch
                      v-model="enableDelEmailedReports"
                      label="Enable Delete"
                  />
               </div>

            </template>

            <span>Enable to delete reports that have been emailed already</span>
         </v-tooltip>



        <v-flex grow></v-flex>


        <v-flex xs12 sm6 md2>
          <v-menu
                  v-model="date_menu1"
                  :close-on-content-click="false"
                  :nudge-right="0"
                  lazy
                  transition="scale-transition"
                  offset-y
                  nudge-bottom="30"
                  full-width
                  max-width="290px"
                  min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                      v-model="date_month"
                      label="Pick Month To View"
                      prepend-icon="event"
                      v-on="on"

              ></v-text-field>
            </template>
            <v-date-picker
                    v-model="date_month"
                    @input="date_menu1 = false"
                    no-title
                    type="month"
                    v-on:change="get_reports_local"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <!--<v-flex xs12 sm6 md4 class="pl-1">-->

          <!--<v-autocomplete-->
                  <!--label="Organization/Dealership"-->
                  <!--:items="dealerships"-->
                  <!--item-value="_id"-->
                  <!--item-text="txt"-->
                  <!--v-model="selectedDealership"-->
                  <!--v-on:change="get_data"-->
          <!--&gt;-->
          <!--</v-autocomplete>-->

        <!--</v-flex>-->


        <!--<v-spacer></v-spacer>-->
        <v-flex xs3 class="pl-2 pr-2">
          <v-text-field
                  v-model="search_txt"
                  clearable
                  prepend-inner-icon="search"
                  label="Search"
                  single-line
                  hide-details
          ></v-text-field>
        </v-flex>

        <v-flex xs12>
          <v-data-table
                  :headers="headers"
                  :items="reports"
                  :search="search_txt"
                  :rows-per-page-items="pagination"
                  :pagination.sync="pagination_settings"
                  class="elevation-1 border-radius6"
                  :loading="loading"
          >
            <template slot="items" slot-scope="props">
              <tr :key="get_report_key(props.item)">

                <td >{{ props.item.org_id ? props.item.org_id.name: '' }}</td>
                <td class="my-col" v-if="show_col_dealer">{{ get_name(props.item.dealer_id)}}</td>
                 <td class="my-col" v-if="show_col_sp">{{ get_name(props.item.sales_person)}}</td>

                <td class="my-col">{{ props.item.curriculum_id.name}}</td>

                <td class="center-td my-col">{{ props.item.report_info.num_leads }}</td>
                <td class="center-td my-col">{{ props.item.report_info.avg_grade }}</td>




                <td class="center-td my-col" v-if="props.item.file_path !== null">
                  <v-icon small class="mr-2" @click="preview_file(props.item)">image</v-icon>
                  <v-icon small class="mr-2" @click="download_file(props.item)">cloud_download</v-icon>
                  <v-icon small class="mr-2" @click="delete_report(props.item)" v-if="props.item.date_emailed===null || enableDelEmailedReports"
                  >delete</v-icon>
                </td>
                <td class="center-td my-col" v-else>
                  <a @click="gen_report_local(props.item)" href="javascript:void(0);" >Generate</a>
                </td>



                <td class="center-td my-col">
                  <div v-if="props.item.date_emailed != null" >
                        {{props.item.date_emailed}}
                  </div>
                  <v-icon v-else-if="props.item.date_emailed === null"
                          medium class="mr-2" @click="open_email_dialog(props.item)">email</v-icon>
                  <div v-else>
                  </div>
                </td>

              </tr>

            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Your search for "{{ search_txt }}" found no results.
              </v-alert>
            </template>
          </v-data-table>
        </v-flex>


      </v-layout>

    </v-container>

  </div>
</template>

<style scoped>
  .center-td{
    text-align: center;
  }

  .myheader{
    font-size: large;
    font-weight: bold;
    color: grey;
  }

  tr >>> .my-col{
      padding-left: 5px !important;
      padding-right: 5px !important;
  }

  /*div >>> .dense.v-input--selection-controls{*/
  /*    margin-top: 0px;*/
  /*}*/

  div >>> .reverse-label-checkbox2 .v-input__slot{
      flex-direction: row-reverse;
      justify-content: flex-end;
  }

  div >>> .v-input--selection-controls__input{
      margin-left: 10px;
  }


  #bulk-table{
      /*border-spacing: 10px;*/
      border-collapse: collapse;
      width: 100%;
      border: 1px solid #757575;
  }
  #bulk-table  td,th{
      border-top: 1px solid #757575;
      border-bottom: 1px solid #757575;
      padding-left: 5px;
      padding-right: 5px;
  }



</style>

<script>

   import data_getters from '../mixins/data_getters';
   import axios from 'axios';
   import pdf from 'vue-pdf';

   import _ from 'lodash';


   export default {
      name: "ReportCard",
      components:{pdf},
      mixins: [data_getters],
      data() {
         return {

            show_bulk: false,
            bulk_res: {log: []},

            bulk_settings: {
               gen_reports: false,
               email_reports: false,
               overwrite_existing: false,
            },
            running_bulk: null,

            batch_key: null, //used to track batch operations
            batch_progress: 0,


            enableDelEmailedReports: false,

            report_type: 'dealership',
            date_month: null,
            date_menu1: false,
            loading: false,

            search_txt: '',
            pdf_data: null,
            pdf_data2: null,
            dialog: false,
            dialog_email: false,

            submit_email_users: false,
            email_item: null, //object used to hold the current row to be emailed

            form_error_txt: null,

            selectedDealership: null,
            dealerships: [],
            reports: [],
            users_agency: [],
            users_client: [],



            // headers: [
            //    {text: 'Group Name', value: 'org_id.name', width: '30%'},
            //    {text: 'Dealership Name', value: 'dealer_id.name', width: '40%'},
            //    {text: 'Curriculum', value: 'curriculum_id.name', width: '5%'},
            //    {text: 'Num Graded Leads', align: 'center', value: 'report_info.num_leads', width: '10%'},
            //    {text: 'Grade', align: 'center', value: 'report_info.avg_grade', width: '10%'},
            //    {text: 'Report Card',  align: 'center', width: '20%', sortable: false},
            //    {text: 'Emailed Date', align: 'center', width: '5%', sortable: false },
            // ],

            pagination: [25, 50, 100, {"text":"All","value":-1}],
            pagination_settings: {
               sortBy: 'dealer_id.name', // The field that you're sorting by
               descending: false,
               rowsPerPage: -1
            },


            report_list:[
               {val: 'organization', txt: 'Organization'},
               {val: 'dealership', txt: 'Dealership'},
               {val: 'sales_person', txt: 'Sales Person'}
            ],


            page: {
               title: "Report Card",
            },
         };
      },

      computed:{

         is_admin(){
            return (this.$auth.profile.acct_type === 'AGENCY' && this.$auth.profile.user_role === 'Admin');
         },

         headers(){
            let ans;
            if (this.report_type === 'sales_person'){
               ans = [
                  {text: 'Group', value: 'org_id.name', width: '30%'},
                  {text: 'Dealership', value: 'dealer_id.name', width: '40%'},
                  {text: 'Sales Person', value: 'sales_person.name', width: '40%'},
                  {text: 'Curriculum', value: 'curriculum_id.name', width: '5%'},
                  {text: '# Leads', align: 'center', value: 'report_info.num_leads', width: '10%'},
                  {text: 'Grade', align: 'center', value: 'report_info.avg_grade', width: '10%'},
                  {text: 'Report Card',  align: 'center', width: '20%', sortable: false},
                  {text: 'Emailed', align: 'center', width: '5%', sortable: false },
               ];
            }else if (this.report_type === 'dealership'){
               ans = [
                  {text: 'Group Name', value: 'org_id.name', width: '30%'},
                  {text: 'Dealership Name', value: 'dealer_id.name', width: '40%'},
                  {text: 'Curriculum', value: 'curriculum_id.name', width: '5%'},
                  {text: '# Leads', align: 'center', value: 'report_info.num_leads', width: '10%'},
                  {text: 'Grade', align: 'center', value: 'report_info.avg_grade', width: '10%'},
                  {text: 'Report Card',  align: 'center', width: '20%', sortable: false},
                  {text: 'Emailed', align: 'center', width: '5%', sortable: false },
               ];
            } else if (this.report_type === 'organization'){
               ans = [
                  {text: 'Group Name', value: 'org_id.name', width: '20%'},
                  {text: 'Curriculum', value: 'curriculum_id.name', width: '20%'},
                  {text: '# Leads', align: 'center', value: 'report_info.num_leads', width: '10%'},
                  {text: 'Grade', align: 'center', value: 'report_info.avg_grade', width: '10%'},
                  {text: 'Report Card',  align: 'center', width: '20%', sortable: false},
                  {text: 'Emailed', align: 'center', width: '5%', sortable: false },
               ];
            }

            return ans;
         },

         show_col_dealer(){
            return ['dealership', 'sales_person'].includes(this.report_type);
         },

         show_col_sp(){
            return ['sales_person'].includes(this.report_type);
         },

         bulk_has_dealer(){
            return ['dealer', 'sales_person'].includes(this.report_type);
         },
         bulk_has_sp(){
            return [ 'sales_person'].includes(this.report_type);
         }

      },

      methods: {

         get_report_key(item){
            let ans = item.org_id._id+'-'+item.curriculum_id._id  ;

            ans += '-'+ _.get(item, 'dealer_id._id', '')
            ans += '-'+ _.get(item, 'sales_person.id', '')





            // let tmp = _.get(item, 'sales_person.id', '')
            // if (tmp===null){
            //    console.log(item)
            // }

            return ans;
         },

         get_name(val){
            return _.get(val, 'name', 'N/A');
         },

         async get_reports_local(){

            this.loading = true;
            this.reports = await this.get_reports({month: this.date_month, groupBy: this.report_type});
            this.loading = false;
         },




         async gen_report_local(item){


            try{

               let q  = {
                  month: item.month, org_id: item.org_id._id, curriculum_id: item.curriculum_id._id,
               };

               if (item.dealer_id != null){
                  q.dealer_id = item.dealer_id._id;
               }


               let sp = _.get(item, 'sales_person.id', null)
               if (sp != null){
                  q.sales_person_id = sp;
               }

               await  this.gen_reports(q);
               await this.get_reports_local();
            }
            catch (err) {
               this.show_error_details(err, 'gen_report_local()');

            }

         },


         async gen_reports_batch(){


            this.bulk_res = {log: []};
            this.running_bulk = true;
            try{
               let type_map = {'organization': 'ORG', 'dealership':'DEALER', 'sales_person':'SALES_PERSON'}
               let groupBy = this.report_type;



               this.batch_key = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

               let {token, query} = await this.base_user_request();
               let url = this.$baseUrlApi + '/genReportCardsBatch';

               let payload = {
                  query: {
                     month: this.date_month,
                     agency_id: this.$auth.profile.agency_id,
                  },
                  groupBy,
                  gen_reports: this.bulk_settings.gen_reports,
                  send_emails: this.bulk_settings.email_reports,
                  overwrite_existing: this.bulk_settings.overwrite_existing,
                  polling_key: this.batch_key,
               }


               this.batch_progress = 0;

               let timer = setInterval(this.poll_batch, 2000);

               let {data} = await axios.post(url, payload, token);


               clearInterval(timer);


               this.batch_progress = 100;
               console.log(data.log)


               await this.get_reports_local();
               this.batch_start = null;

               setTimeout(()=>{this.running_bulk = false; this.bulk_res = data;}, 1000);

            }
            catch (err) {
               this.show_error_details(err, 'gen_report_batch()');

            }



         },

         async poll_batch(){
            try{


               let groupBy = this.report_type;

               let {token, query} = await this.base_user_request();
               let url = this.$baseUrlApi + '/genReportCardsBatchPoll';

               let payload = {
                  polling_key: this.batch_key,
               }

               let {data} = await axios.post(url, payload, token);

               console.log('polling', data)

               this.batch_progress = data.progress*100;
               console.log(data.log)



            }
            catch (err) {
               this.show_error_details(err, 'gen_report_batch()');

            }
         },


         close_bulk_dialog(){
            this.show_bulk=false;
            this.bulk_res = {log:[]};
            this.bulk_settings = {
               gen_reports: false,
               email_reports: false,
               overwrite_existing: false,
            };

         },


         async get_users_local(item){


            try{

               let {token, query} = await this.base_user_request();
               let url = this.$baseUrlApi + '/getReportCardUsers';

               query.report_id = item._id;
               let {data} = await axios.post(url, query, token);


               for (let i in data.client_users){
                  data.client_users[i].loc_checked = true;
               }

               for (let i in data.agency_users){
                  data.agency_users[i].loc_checked = true;
               }


               this.users_client = data.client_users;
               this.users_agency = data.agency_users;

            } catch (e) {
               console.error(e)
            }
         },



         // async get_users_local_old(item){
         //
         //    let q_c = {acct_type: 'CLIENT', };
         //    let q_a = {acct_type: 'AGENCY'};
         //
         //    if (this.report_type==='organization'){
         //       q_c.include_on_reports_org = true;
         //       q_c.org_id = item.org_id._id;
         //
         //       q_a.include_on_reports_org = true;
         //    }
         //    else if (this.report_type==='dealership'){
         //       q_c.include_on_reports = true;
         //       q_c.dealer_id = item.dealer_id._id;
         //
         //       q_a.include_on_reports = true;
         //
         //    }
         //    else if (this.report_type==='sales_person'){
         //       q_c.include_on_reports_sp = true;
         //       q_c.dealer_id = item.dealer_id._id;
         //
         //       q_a.include_on_reports_sp = true;
         //    }
         //
         //    console.log({q_c, q_a})
         //
         //    let u1 = this.get_users(q_c);
         //    let u2 = this.get_users(q_a);
         //
         //    let data = await Promise.all([u1, u2]);
         //
         //    for (let i in data[0]){
         //       data[0][i].loc_checked = true;
         //    }
         //
         //    for (let i in data[1]){
         //       data[1][i].loc_checked = true;
         //    }
         //
         //    this.users_client = data[0];
         //    this.users_agency = data[1];
         //
         //
         // },


         async download_file(item){
            try{
               console.log('download_file', item);
               let filename = item.file_path;
               let save_name = filename.split('/');
               save_name = save_name[save_name.length-1];
               if (this.report_type === 'dealership'){
                  save_name = item.dealer_id.name + '_' + save_name;
               }
               else if (this.report_type === 'organization'){
                  save_name = item.org_id.name + '_' + save_name;
               }
               else if (this.report_type === 'sales_person'){
                  save_name = item.sales_person.name + '_' + save_name;
               }


               let response = await this.get_file(filename);

               const url = URL.createObjectURL(new Blob([response.data]));
               const link = document.createElement('a');
               link.href = url;
               link.setAttribute('download', save_name );
               document.body.appendChild(link);
               link.click();
            }
            catch (err) {
               this.show_error_details(err, 'download_file()');

            }

         },



         async delete_report(item){


            let {token} = await this.base_user_request();
            let url = this.$baseUrlApi + '/deleteReportCard';


            try {
               await axios.post(url, {query: {report_id: item._id}}, token);
               this.get_reports_local();
            } catch (err) {
               this.show_error_details(err, 'delete_report()');
            }
         },



         async preview_file(item, openPreview=true){
            let response = await this.get_file(item.file_path);
            let tmp = new Blob([response.data]);
            this.pdf_data = URL.createObjectURL(tmp);

            if (openPreview) this.dialog = true;

         },

         close_preview(){
            this.dialog = false;
            URL.revokeObjectURL(this.pdf_data);
         },


         async open_email_dialog(item){

            await this.get_users_local(item); //not sure why but if these two lines are switched, then the pdf isn't displayed
            await this.preview_file(item, false);

            this.email_item = item;
            this.dialog_email = true;

         },

         close_email_dialog(){
            this.dialog_email = false;
            URL.revokeObjectURL(this.pdf_data);
         },



         //*************************************************************************************************************
         async send_emails(){
            this.submit_email_users = true;

            let email_list = [];
            let email_cc = [];

            // create to list
            let list = this.users_client;
            for (let i=0; i<list.length; i++){
               if(list[i].loc_checked) {
                  email_list.push(list[i].email)
               }
            }

            //add admins/acctManagers
            for (let i=0; i<this.users_agency.length; i++){
               if(this.users_agency[i].loc_checked){
                  email_cc.push(this.users_agency[i].email)
               }

            }


            // if (email_list.length === 0){
            //    email_list = Object.assign(email_cc, []);
            //    email_cc = [];
            // }


            console.log('email_list', email_list);
            console.log('email_cc', email_cc);

            let email_data = {
               to      : email_list,
               cc      : email_cc,
               file_key: this.email_item.file_path

            };

            let {token} = await this.base_user_request();
            let url = this.$baseUrlApi + '/sendEmailReportCard';


            let team_name = this.email_item.org_id.name;

            if (this.email_item.dealer_id){
               team_name = this.email_item.dealer_id.name;
            }

            if (this.email_item.sales_person.id){
               team_name = this.email_item.sales_person.name;
            }


            let post_data = {
               email_data: email_data,
               month: this.email_item.month,
               dealer_name: team_name,
               rc_id: this.email_item._id,
               agency_id: this.$auth.profile.agency_id
            };

            try {
               await axios.post(url, post_data, token);
               this.email_item = null;
               this.dialog_email = false;
               this.get_reports_local();


            }
            catch(err) {
               console.error(err.response);
               this.form_error_txt = err.response.data;
            }


            this.submit_email_users = false;
         },



      },

      watch:{
         dialog: function (newval, oldval,){
            //added so that if the user clicks out of the previewer, we still revoke the url obj
            if (newval === false){
               URL.revokeObjectURL(this.pdf_data);
            }
         },
      },


      async created(){
         // let d = new Date();


         let d  = this.get_prev_month();
         this.date_month = d.toISOString().slice(0, 7);
         await this.get_reports_local();




      }
   };
</script>
